const getCountryPrefix = (idiom: string): string =>
  idiom.substring(idiom.length - 2, idiom.length);

export default getCountryPrefix;
